import _objectSpread from '@babel/runtime/helpers/objectSpread2';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import styled from 'styled-components';
import { spacing2x } from '../../styles/spacing.js';
import { getAdornment } from '../../utils/adornment.js';
import { Tooltip } from '../Tooltip/Tooltip.js';
import { jsxs, jsx } from 'react/jsx-runtime';

var _excluded = ["children", "startAdornment", "tooltipProps"];
var CardTitleWrapper = styled.div.withConfig({
  displayName: "CardTitle__CardTitleWrapper",
  componentId: "sc-112l9gr-0"
})(["&&{display:flex;gap:", ";}"], spacing2x);
var CardTitleAnchor = styled.a.withConfig({
  displayName: "CardTitle__CardTitleAnchor",
  componentId: "sc-112l9gr-1"
})(["&&{-webkit-box-orient:vertical;-webkit-line-clamp:1;color:", ";cursor:pointer;display:-webkit-box;line-height:20px;overflow:hidden;position:relative;text-overflow:ellipsis;white-space:normal;word-break:break-all;}&&:hover,&&:focus{color:", ";}"], function (props) {
  return props.theme.neutralColors.charcoal;
}, function (props) {
  return props.theme.neutralColors.charcoal;
});
var CardTitleAdornment = styled.div.withConfig({
  displayName: "CardTitle__CardTitleAdornment",
  componentId: "sc-112l9gr-2"
})(["&&{display:inline-flex;line-height:0;height:20px;vertical-align:top;}"]);
var CardTitleAdornmentPositioner = styled.div.withConfig({
  displayName: "CardTitle__CardTitleAdornmentPositioner",
  componentId: "sc-112l9gr-3"
})(["&&{align-items:center;display:flex;flex:1;}&& button{min-height:unset;min-width:unset;padding:0;}&& button:hover,&& button:focus{background-color:transparent;transition:none;}"]);
var CardTitle = /*#__PURE__*/React.forwardRef(function CardTitle2(props, ref) {
  var children = props.children,
    startAdornment = props.startAdornment,
    tooltipProps = props.tooltipProps,
    rest = _objectWithoutProperties(props, _excluded);
  return /*#__PURE__*/jsxs(CardTitleWrapper, {
    children: [startAdornment && /*#__PURE__*/jsx(CardTitleAdornment, {
      children: /*#__PURE__*/jsx(CardTitleAdornmentPositioner, {
        children: getAdornment(startAdornment, {
          iconSize: 24
        })
      })
    }), /*#__PURE__*/jsx(Tooltip, _objectSpread(_objectSpread({
      content: children
    }, tooltipProps), {}, {
      children: /*#__PURE__*/jsx(CardTitleAnchor, _objectSpread(_objectSpread({}, rest), {}, {
        ref: ref,
        children: children
      }))
    })), " "]
  });
});
CardTitle.displayName = "CardTitle";

export { CardTitle };
